const goldenHordeBorder = [
	'M',
	[46.479, 32.311],
	'Q',
	[48, 37.3],
	[49.01, 33.416667],
	'M',
	[49.01, 33.416667],
	'Q',
	[51.674722, 33.2],
	[53.2, 37.71],
	'M',
	[53.2, 37.71],
	'Q',
	[54.6, 42.7],
	[57.2, 47],
	'M',
	[57.2, 47],
	'Q',
	[57.6, 48.7],
	[57.4099, 50.7277],
	'M',
	[57.4099, 50.7277],
	'Q',
	[56.9, 54.6],
	[56.2, 55.5],
];

export default goldenHordeBorder;
